module.exports = __webpack_public_path__ + "static/media/text-color.a662438d.svg";